module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-03.f2658583.jpg";